import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import productPlaceholderImage from '../../../../img/product-image-placeholder.png'

// TODO Add variant information in addition to just the quantity.
const ShipmentItem = ({ className, item, products }) => {
  const product = products.find((productItem) => productItem.sku === item.sku)

  return (
    <div className={className}>
      <div className="item-details">
        <img
          alt={product ? product.image.label : ''}
          className="item-image"
          src={product ? product.image.url : productPlaceholderImage}
        />
        <div>
          <h5 className={classnames('roboto', { noProduct: !product })}>
            {product ? product.name : `Item with SKU ${item.sku}`}
          </h5>
          <div className={classnames('small-paragraph-text', { noProduct: !product })}>
            Quantity Shipped: {item.quantity}
          </div>
        </div>
      </div>
    </div>
  )
}

ShipmentItem.defaultProps = {
  className: '',
}

ShipmentItem.propTypes = {
  className: PropTypes.string,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string,
      }),
      sku: PropTypes.string,
    }),
  ).isRequired,
  item: PropTypes.shape({
    amount: PropTypes.number,
    quantity: PropTypes.number,
    sku: PropTypes.string,
  }).isRequired,
}

const StyledShipmentItem = styled(ShipmentItem)(({ theme }) => ({
  backgroundColor: theme.colors.grayscale.white,
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 25px 15px',
  '&:first-child': {
    borderRadius: '8px 8px 0px 0px',
  },
  '&:last-child': {
    borderRadius: '0px 0px 8px 8px',
  },
  '&:not(:last-of-type)': {
    marginBottom: '16px',
  },
  '.item-image': {
    borderRadius: '4px',
    height: '115px',
    marginRight: '8px',
    width: '115px',
  },
  '.item-details': {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  '.small-paragraph-text': {
    color: theme.colors.grayscale.black,
    marginBottom: '8px',
  },
  '@media(min-width: 992px)': {
    flexDirection: 'row',
  },
  '.noProduct': {
    color: theme.colors.grayscale.gray40,
  },
}))

export default StyledShipmentItem
